export const FETCH_MESSAGE_ROOM_STATISTIC = "[MESSAGE_ROOM_STATISTIC] FETCH_MESSAGE_ROOM_STATISTIC";
export const FETCH_MESSAGE_ROOM_STATISTIC_SUCCESS = "[MESSAGE_ROOM_STATISTIC] FETCH_MESSAGE_ROOM_STATISTIC_SUCCESS";
export const FETCH_MESSAGE_ROOM_STATISTIC_FAILED = "[MESSAGE_ROOM_STATISTIC] FETCH_MESSAGE_ROOM_STATISTIC_FAILED";
